import { expectType, zDocument } from './model.js';
import z from 'zod';
export const EMAIL_CATEGORIES = [
    'notification',
    'registration',
    'password-reset',
    'email-login',
    'user-feedback'
];
export const zEmailLog = zDocument.extend({
    type: z.literal('emailLog'),
    email: z.string(),
    bcc: z.array(z.string()).optional(),
    body: z.string(),
    subject: z.string(),
    category: z.enum(EMAIL_CATEGORIES).or(z.literal('')),
    error: z.string().optional(),
    sent: z.boolean()
});
expectType({});
expectType({});
export const EmptyEmailLog = {
    type: 'emailLog',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    email: '',
    bcc: [],
    subject: '',
    body: '',
    category: '',
    sent: false
};
export function isEmailCategory(category) {
    return EMAIL_CATEGORIES.includes(category);
}
